import React from 'react';
import { formatDateOnly, formatPrice } from '../utils';
import { deadlineTimeLabel } from '../offerExpiration';
import { getContingencyLabel, getSelectedContingencyKeys } from '../contingencyCatalog';
import './WizardSummarySidebar.css';

function SummaryBody({ wiz, property }) {
  const d = wiz.derived;
  const thumb = property?.image_url || (Array.isArray(property?.images) && property.images[0]) || null;
  const address = property?.address || property?.property_address || 'Selected property';
  const activeContingencies = getSelectedContingencyKeys(wiz.form.contingencies);

  return (
    <div className="wizard-summary__body">
      <div className="wizard-summary__property">
        {thumb ? (
          <img src={thumb} alt="" className="wizard-summary__thumb" />
        ) : (
          <div className="wizard-summary__thumb wizard-summary__thumb--placeholder" aria-hidden="true">🏠</div>
        )}
        <div className="wizard-summary__address">{address}</div>
      </div>

      <h3 className="wizard-summary__title">Order summary</h3>

      <dl className="wizard-summary__rows">
        <div className="wizard-summary__row">
          <dt>Offer price</dt>
          <dd>{formatPrice(d.offerPrice)}</dd>
        </div>
        <div className="wizard-summary__row">
          <dt>Down payment</dt>
          <dd>
            {formatPrice(d.dpAmount)}
            <span className="wizard-summary__meta"> · {d.dpPct}%</span>
          </dd>
        </div>
        <div className="wizard-summary__row">
          <dt>Financed amount</dt>
          <dd>{formatPrice(d.financedAmount)}</dd>
        </div>
        {d.monthlyPI > 0 && (
          <div className="wizard-summary__row wizard-summary__row--accent">
            <dt>Est. monthly P&amp;I</dt>
            <dd>{formatPrice(d.monthlyPI)}</dd>
          </div>
        )}
        <div className="wizard-summary__row">
          <dt>Earnest money</dt>
          <dd>{d.earnest > 0 ? formatPrice(d.earnest) : '—'}</dd>
        </div>
        <div className="wizard-summary__row">
          <dt>Closing date</dt>
          <dd>{wiz.form.closing_date || '—'}</dd>
        </div>
        <div className="wizard-summary__row">
          <dt>Offer deadline</dt>
          <dd>
            {wiz.form.expires_on
              ? `${formatDateOnly(wiz.form.expires_on)}, ${deadlineTimeLabel(wiz.form.expires_on, property?.timezone)}`
              : '—'}
          </dd>
        </div>
      </dl>

      <div className="wizard-summary__divider" />

      <h4 className="wizard-summary__subtitle">Active contingencies</h4>
      {activeContingencies.length === 0 ? (
        <p className="wizard-summary__empty">None selected — non-contingent offer.</p>
      ) : (
        <ul className="wizard-summary__contingencies">
          {activeContingencies.map((key) => (
            <li key={key} className="wizard-summary__contingency wizard-summary__contingency--on">
              <span className="wizard-summary__check" aria-hidden="true">✔</span>
              <span>{getContingencyLabel(key)}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default function WizardSummarySidebar({ wiz, property }) {
  return (
    <div className="wizard-summary">
      <SummaryBody wiz={wiz} property={property} />
    </div>
  );
}

export function WizardSummaryDisclosure({ wiz, property }) {
  const offer = wiz.derived.offerPrice;
  return (
    <details className="wizard-summary-disclosure">
      <summary className="wizard-summary-disclosure__summary">
        <span>Order summary</span>
        <span className="wizard-summary-disclosure__price">{formatPrice(offer)}</span>
      </summary>
      <div className="wizard-summary-disclosure__body">
        <SummaryBody wiz={wiz} property={property} />
      </div>
    </details>
  );
}
